var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Leaflet from 'leaflet';
const markerFactory = {
    entityName: 'Marker',
    createLayer(state) {
        const { latlng } = state, options = __rest(state, ["latlng"]);
        return Leaflet.marker(latlng, options);
    },
    updateLayer(layer, state, nextState) {
        const { latlng, icon } = nextState;
        if (state.latlng[0] !== latlng[0] || state.latlng[1] !== latlng[1])
            layer.setLatLng(latlng);
        if (state.icon !== icon)
            layer.setIcon(icon);
    },
};
export default markerFactory;
